import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'
import toast from 'react-hot-toast'
import { useParams } from 'react-router-dom'
import { getVCardByUUID } from '../../services'
import { normalizeVCardUuid } from '../../utils/vcard-public'
import VCardPublicView from '../shared/VCardPublicView'

const VCardDetail = () => {
    const { uuid: routeUuid } = useParams<{ uuid: string }>()
    const uuid = normalizeVCardUuid(routeUuid)

    const { data, renderState } = useQueryWithHandler({
        queryKey: [QUERY_KEYS.VCARDS, uuid],
        queryFn: async () => {
            try {
                return await getVCardByUUID(uuid)
            } catch (error) {
                toast.error('' + error)
            }
        },
        enabled: Boolean(uuid),
    })

    const stateComponent = renderState()
    if (stateComponent) return stateComponent

    if (!data?.result || !uuid) {
        return (
            <div className="w-full min-h-screen bg-[#FFF7F7] flex items-center justify-center p-8 text-center text-gray-500">
                VCard not found
            </div>
        )
    }

    return (
        <div className="w-full min-h-screen bg-[#FFF7F7] py-4 px-3">
            <VCardPublicView vcard={data.result} uuid={uuid} mode="public" />
        </div>
    )
}

export default VCardDetail
